import { fetchWithHeaders, responseData } from '../shared/utils'

export function getSunset() {
  const queryParams = window.location.search
  return fetchWithHeaders(`/users/sunset${queryParams}`, {
    method: 'GET',
  }).then(responseData)
}

export function updateSunset(opts = {}) {
  return fetchWithHeaders(`/users/sunset`, {
    method: 'PUT',
    body: JSON.stringify(opts),
  })
    .then(responseData)
    .catch(err => {
      return err
    })
}

export function getSunsetModeStatus() {
  return fetchWithHeaders('/sunset', {
    method: 'GET',
  }).then(responseData)
}
